import { LabelValueSet } from "../utility/LabelValueSet";

const DiseaseType = Symbol();

export class Disease extends LabelValueSet  {
    [DiseaseType]: any;
}

const 前立腺肥大症 = new Disease("前立腺肥大症", "前立腺肥大症");
const 前立腺がん = new Disease("前立腺がん", "前立腺がん");
const 過活動膀胱 = new Disease("過活動膀胱", "過活動膀胱");
const 膀胱炎 = new Disease("膀胱炎", "膀胱炎");
const 尿細管壊死 = new Disease("尿細管壊死", "尿細管壊死");
const 腎炎 = new Disease("腎炎", "腎炎");
const ネフローゼ症候群 = new Disease("ネフローゼ症候群", "ネフローゼ症候群");
const 慢性腎盂腎炎 = new Disease("慢性腎盂腎炎", "慢性腎盂腎炎");
const 水腎症 = new Disease("水腎症", "水腎症");
const 腎不全 = new Disease("腎不全", "腎不全");
const 腎結核 = new Disease("腎結核", "腎結核");
const 胞腎 = new Disease("胞腎", "胞腎");
const 高血圧 = new Disease("高血圧症", "高血圧");
const 脳出血 = new Disease("脳出血", "脳出血");
const くも膜下出血 = new Disease("くも膜下出血", "くも膜下出血");
const 脳梗塞 = new Disease("脳梗塞", "脳梗塞");
const 心筋梗塞 = new Disease("心筋梗塞", "心筋梗塞");
const 狭心症 = new Disease("狭心症", "狭心症");
const 心不全 = new Disease("心不全", "心不全");
const 弁膜症 = new Disease("弁膜症", "弁膜症");
const 不整脈 = new Disease("不整脈", "不整脈");
const COPD = new Disease("慢性閉塞性肺疾患（COPD）", "COPD");
const 呼吸不全 = new Disease("呼吸不全", "呼吸不全");
const 喘息 = new Disease("喘息", "喘息");
const 認知症 = new Disease("認知症", "認知症");
const 大腿骨頸部骨折 = new Disease("大腿骨頸部骨折（大腿骨近位部骨折）", "大腿骨頸部骨折");
const その他心疾患 = new Disease("その他心疾患", "その他心疾患");
const その他脳血管疾患 = new Disease("その他脳血管疾患", "その他脳血管疾患");

const mapValueToItem: { [key: string] : Disease} = {
    "前立腺肥大症": 前立腺肥大症,
    "前立腺がん": 前立腺がん,
    "過活動膀胱": 過活動膀胱,
    "膀胱炎": 膀胱炎,
    "尿細管壊死": 尿細管壊死,
    "腎炎": 腎炎,
    "ネフローゼ症候群": ネフローゼ症候群,
    "慢性腎盂腎炎": 慢性腎盂腎炎,
    "水腎症": 水腎症,
    "腎不全": 腎不全,
    "腎結核": 腎結核,
    "胞腎": 胞腎,
    "高血圧": 高血圧,
    "脳出血": 脳出血,
    "くも膜下出血": くも膜下出血,
    "脳梗塞": 脳梗塞,
    "心筋梗塞": 心筋梗塞,
    "狭心症": 狭心症,
    "心不全": 心不全,
    "弁膜症": 弁膜症,
    "不整脈": 不整脈,
    "COPD": COPD,
    "呼吸不全": 呼吸不全,
    "喘息": 喘息,
    "認知症": 認知症,
    "大腿骨頸部骨折": 大腿骨頸部骨折,
    "その他心疾患": その他心疾患,
    "その他脳血管疾患": その他脳血管疾患
};

export const diseaseList: readonly Disease[] = [
    前立腺肥大症,
    前立腺がん,
    過活動膀胱,
    膀胱炎,
    尿細管壊死,
    腎炎,
    ネフローゼ症候群,
    慢性腎盂腎炎,
    水腎症,
    腎不全,
    腎結核,
    胞腎,
    高血圧,
    COPD,
    呼吸不全,
    喘息,
    認知症,
    大腿骨頸部骨折
];

export const heartDiseaseList: readonly Disease[] = [
    心筋梗塞,
    心不全,
    狭心症,
    弁膜症,
    不整脈,
    その他心疾患
];

export const brainBloodVesselDiseaseList: readonly Disease[] = [
    脳梗塞,
    脳出血,
    くも膜下出血,
    その他脳血管疾患
];

export const getDiseaseFromValue = (value: string): Disease | undefined => {
    return mapValueToItem[value];
};

export type DiseaseJson = {
    disease: string
};
